<template>
  <div id="phone_number_section" class="flex flex-col gap-6">
    <div id="phone_number" class="form_col" v-if="shouldShowPhoneNumber">
      <span class="secondary_color text-[13px]">Phone Number</span>

      <SkeletonLoader
        v-if="regeneratingNumber"
        :page="loaderPages.GENERATE_NUMBER"
      />

      <div
        v-else
        class="flex flex-row w-full justify-between items-center bg_white_4 p-4 rounded-lg"
      >
        <div class="flex flex-row items-center gap-3">
          <ProfileIcon
            :size="40"
            :custom-avatar="getCountryFlag"
            :data="internalFormData.generatedNumberDetails"
          />

          <div class="flex flex-col gap-[6px]">
            <span class="text-2xl text_color font-semibold">{{
              internalFormData.generatedNumberDetails.friendly_name
            }}</span>
            <span class="text-[13px] text_color">{{
              internalFormData.generatedNumberDetails.area
            }}</span>
          </div>
        </div>

        <a-button
          v-if="enableRegenerate"
          class="secondary_medium"
          @click="$emit('regenerate')"
        >
          Regenerate
        </a-button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { loaderPages } from "@/src/constants/loaderConstants.js";
import { getCountryCode } from "@/src/utils/phoneNumberUtils.js";
import { countryFlagMapping } from "@/src/constants/phoneNumberConstants.js";
import ProfileIcon from "@/src/components/ProfileIcon.vue";
import SkeletonLoader from "@/src/components/SkeletonLoader.vue";

const props = defineProps({
  internalFormData: { type: Object, required: true },
  enableRegenerate: { type: Boolean, default: true },
  regeneratingNumber: { type: Boolean, required: false },
  shouldShowPhoneNumber: { type: Boolean, required: true },
});

const emits = defineEmits(["regenerate"]);

const getCountryFlag = computed(() => {
  return {
    icon: countryFlagMapping[
      getCountryCode(props.internalFormData.generatedNumberDetails.number)
    ],
    size: 40,
  };
});
</script>
